import { Instagram, Youtube, Twitter, Activity, Podcast, ArrowUpRight } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";

const PLATFORMS = [
  {
    icon: Instagram,
    name: "Instagram",
    handle: "@fit50official",
    stats: "Growing daily — @fit50official",
    desc: "Daily workout clips, form technique breakdowns, and athlete showcases.",
    href: "https://instagram.com/fit50official",
    testid: "social-link-instagram",
  },
  {
    icon: Youtube,
    name: "YouTube",
    handle: "FIT50 Channel",
    stats: "Coming soon",
    desc: "In-depth video masterclasses on time-efficient training and perfect form.",
    href: "https://youtube.com/@fit50",
    testid: "social-link-youtube",
  },
  {
    icon: Twitter,
    name: "X / Twitter",
    handle: "@fit50official",
    stats: "Coming soon",
    desc: "Daily exercise science insights and longevity research breakdowns.",
    href: "https://x.com/fit50official",
    testid: "social-link-twitter",
  },
  {
    icon: Activity,
    name: "Strava Club",
    handle: "Fit50 Masters",
    stats: "Be a founding member",
    desc: "Track member achievements, weekly mileage, and lift logs globally.",
    href: "https://strava.com/clubs/fit50masters",
    testid: "social-link-strava",
  },
  {
    icon: Podcast,
    name: "Spotify Podcast",
    handle: "The Fit50 Show",
    stats: "Coming soon",
    desc: "Weekly interviews with coaches, sports scientists, and busy people who still train.",
    href: "https://open.spotify.com/show/fit50",
    testid: "social-link-spotify",
  },
];

export const Socials = () => (
  <section id="community" data-testid="socials-section" className="relative py-32 bg-carbon scroll-mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <Eyebrow>Join The Movement</Eyebrow>
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-3xl">
          Follow Fit50 <span className="text-volt">everywhere</span>
        </h2>
        <p className="mt-5 max-w-xl text-base sm:text-lg text-neutral-400 leading-relaxed">
          We&rsquo;re just getting started — be one of the first. Free workouts for every
          duration, founding-member stories, and a community that never says &ldquo;no time&rdquo;.
        </p>
      </FadeUp>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {PLATFORMS.map((p, i) => (
          <FadeUp key={p.name} delay={i * 0.07} className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}>
            <a
              data-testid={p.testid}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col h-full border border-white/10 bg-carbon p-8 overflow-hidden hover:border-volt/60 hover:-translate-y-1 transition-[border-color,transform] duration-300"
            >
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "radial-gradient(circle at 50% 0%, rgba(255,107,0,0.08) 0%, transparent 70%)" }} />
              <div className="relative flex items-start justify-between">
                <p.icon className="h-8 w-8 text-volt" />
                <ArrowUpRight className="h-5 w-5 text-neutral-500 group-hover:text-volt group-hover:translate-x-1 group-hover:-translate-y-1 transition-[color,transform] duration-300" />
              </div>
              <h3 className="relative font-display font-extrabold uppercase text-2xl mt-6">{p.name}</h3>
              <p className="relative font-mono text-[11px] tracking-widest uppercase text-volt mt-1">{p.handle}</p>
              <p className="relative mt-4 text-sm text-neutral-500 leading-relaxed flex-1">{p.desc}</p>
              <p className="relative mt-6 pt-4 border-t border-white/10 font-mono text-[11px] tracking-widest uppercase text-neutral-400">
                {p.stats}
              </p>
            </a>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
